import { render, staticRenderFns } from "./NeedTrainingComponent.vue?vue&type=template&id=2bb7799e&scoped=true"
import script from "./NeedTrainingComponent.vue?vue&type=script&lang=js"
export * from "./NeedTrainingComponent.vue?vue&type=script&lang=js"
import style0 from "./NeedTrainingComponent.vue?vue&type=style&index=0&id=2bb7799e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7799e",
  null
  
)

export default component.exports